// Undo the browser default popover styles that fight Shoelace positioning
const POPOVER_DEFAULT_STYLE_RESET = {
  margin: '0',
  right: 'auto',
  bottom: 'auto',
  padding: '0',
  border: 'none',
  overflow: 'visible',
  color: 'inherit',
  background: 'transparent'
};

/**
 * Show the popup of every hoisted Shoelace component inside an element in the browser top layer, unclipped by any ancestor.
 * @param {HTMLElement} containerElement The element whose Shoelace descendants should show unclipped popups.
 */
export function showShoelacePopupsInTopLayer(containerElement) {
  // Move a popup into the top layer when its component shows and out when it hides
  const movePopupForShoelaceEvent = (event) => {
    // Read the hoisted popup from the component because Shoelace 2 lacks top layer support
    const [openableComponent] = event.composedPath();
    const popupPositioner = openableComponent.popup;
    const isPopupHoisted = popupPositioner?.strategy === 'fixed';
    const popupElement = popupPositioner?.popup;
    if (!popupElement?.isConnected || !isPopupHoisted) return;

    // Show the popup as a top layer popover while its component is open
    popupElement.popover = 'manual';
    Object.assign(popupElement.style, POPOVER_DEFAULT_STYLE_RESET);
    popupElement.togglePopover(openableComponent.open);
  };
  containerElement.addEventListener('sl-show', movePopupForShoelaceEvent);
  containerElement.addEventListener('sl-after-hide', movePopupForShoelaceEvent);
}
